// Reducer for the details of a topic.

import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'

export const DefaultTrackerListState = {
  ...DefaultState
}

export const trackerList = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTrackerListState,
  actionRequest: ActionTypes.REQUEST_TRACKER,
  actionFailure: ActionTypes.REQUEST_TRACKER_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TRACKER,
  actionInvalidate: ActionTypes.INVALIDATE_TRACKER
})

export const DefaultTrackerIdState = {
  ...DefaultState
}

export const trackerPlanDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTrackerIdState,
  actionRequest: ActionTypes.REQUEST_TRACKER_PLAN,
  actionFailure: ActionTypes.REQUEST_TRACKER_PLAN_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TRACKER_PLAN
})

export const trackerTimelineView = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTrackerIdState,
  actionRequest: ActionTypes.REQUEST_TRACKER_TIMELINE_VIEW,
  actionFailure: ActionTypes.REQUEST_TRACKER_TIMELINE_VIEW_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TRACKER_TIMELINE_VIEW
})


export const trackerAverageBenchMarkPlanDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTrackerIdState,
  actionRequest: ActionTypes.REQUEST_AVERAGE_BENCH_MARK_TRACKER_PLAN,
  actionFailure: ActionTypes.REQUEST_AVERAGE_BENCH_MARK_TRACKER_PLAN_FAILURE,
  actionReceive: ActionTypes.RECEIVE_AVERAGE_BENCH_MARK_TRACKER_PLAN
})

export const trackerAverageBenchMarkTimelineView = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTrackerIdState,
  actionRequest: ActionTypes.REQUEST_AVERAGE_BENCH_MARK_TRACKER_TIMELINE_VIEW,
  actionFailure: ActionTypes.REQUEST_AVERAGE_BENCH_MARK_TRACKER_TIMELINE_VIEW_FAILURE,
  actionReceive: ActionTypes.RECEIVE_AVERAGE_BENCH_MARK_TRACKER_TIMELINE_VIEW
})

export const DefaultTrackerSinglePlanState = {
  ...DefaultState
}

export const trackerSingleTrackerPlanDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTrackerSinglePlanState,
  actionRequest: ActionTypes.REQUEST_SINGLE_TRACKER_PLAN,
  actionFailure: ActionTypes.REQUEST_SINGLE_TRACKER_PLAN_FAILURE,
  actionReceive: ActionTypes.RECEIVE_SINGLE_TRACKER_PLAN
})

export const DefaultTrackerSingleTimeLineViewState = {
  ...DefaultState
}

export const trackerSingleTrackerTimelineView = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTrackerSingleTimeLineViewState,
  actionRequest: ActionTypes.REQUEST_SINGLE_TRACKER_TIMELINE_VIEW,
  actionFailure: ActionTypes.REQUEST_SINGLE_TRACKER_TIMELINE_VIEW_FAILURE,
  actionReceive: ActionTypes.RECEIVE_SINGLE_TRACKER_TIMELINE_VIEW
})

export const DefaultTrackerPrimaryEntityState = {
  ...DefaultState
}

export const trackerPrimaryEntity = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTrackerPrimaryEntityState,
  actionRequest: ActionTypes.REQUEST_TRACKER_PRIMARY_ENTITY_DETAILS,
  actionFailure: ActionTypes.REQUEST_TRACKER_PRIMARY_ENTITY_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TRACKER_PRIMARY_ENTITY_DETAILS
})

export const DefaultTrackerTeasersAndTrailersState = {
  ...DefaultState
}

export const trackerTeasersAndTrailers = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTrackerTeasersAndTrailersState,
  actionRequest: ActionTypes.REQUEST_TRACKER_TEASERS_TRAILERS,
  actionFailure: ActionTypes.REQUEST_TRACKER_TEASERS_TRAILERS_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TRACKER_TEASERS_TRAILERS
})

export const DefaultWhatsNewState = {
  ...DefaultState
}

export const trackerpageWhatsNew = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultWhatsNewState,
  actionRequest: ActionTypes.REQUEST_TRACKER_WHATS_NEW,
  actionFailure: ActionTypes.REQUEST_TRACKER_WHATS_NEW_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TRACKER_WHATS_NEW,
  actionInvalidate: ActionTypes.INVALIDATE_TRACKER_WHATS_NEW
})

export const DefaultWordCloudState = {
  ...DefaultState
}

export const trackerpageWordCloud = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultWordCloudState,
  actionRequest: ActionTypes.REQUEST_TRACKER_WORD_CLOUD,
  actionFailure: ActionTypes.REQUEST_TRACKER_WORD_CLOUD_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TRACKER_WORD_CLOUD,
  actionInvalidate: ActionTypes.INVALIDATE_TRACKER_WORD_CLOUD
})
